import React from 'react';
import { Input } from './styles';

export default function TalkToUsInput({placeholder, value, onChange, name}) {
    return (
        <Input spellCheck={false} name={name} placeholder={placeholder} value={value} onChange={onChange}/>
    )
}
